import { ChevronDown, ChevronRight } from "lucide-react";

type Props = {
  title: string;
  hint: string;
  tag: string;
  count: number;
  notSaved: number;
  open: boolean;
  onToggle: () => void;
};

export function ReviewGroupHeader({
  title,
  hint,
  tag,
  count,
  notSaved,
  open,
  onToggle,
}: Props) {
  const Chevron = open ? ChevronDown : ChevronRight;
  return (
    <button
      type="button"
      aria-expanded={open}
      onClick={onToggle}
      className="sticky top-16 z-10 flex w-full items-center gap-2 border-b border-slate-200 bg-slate-50 px-3 py-2 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-500 dark:border-slate-800 dark:bg-slate-900"
    >
      <Chevron aria-hidden className="h-4 w-4 shrink-0 text-slate-500" />
      <span className="whitespace-nowrap text-sm font-semibold text-slate-900 dark:text-slate-100">
        {title}
      </span>
      <span
        className={`shrink-0 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ${
          tag === "Decision pending"
            ? "border border-orange-200 bg-orange-50 text-orange-800 dark:border-orange-900 dark:bg-orange-950/40 dark:text-orange-200"
            : "border border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300"
        }`}
      >
        {tag}
      </span>
      <span className="shrink-0 rounded-full bg-slate-200 px-2 py-0.5 text-xs font-medium text-slate-700 dark:bg-slate-700 dark:text-slate-200">
        {count}
      </span>
      {notSaved > 0 && (
        <span className="shrink-0 whitespace-nowrap text-xs font-medium text-orange-700 dark:text-orange-300">
          {notSaved} not saved
        </span>
      )}
      <span
        title={hint}
        className="min-w-0 truncate text-xs text-slate-500 dark:text-slate-400"
      >
        {hint}
      </span>
    </button>
  );
}
